// Beach or cliff? One pure rule shared by the land shader masks (terrainEdges), the shoreline ramp layout and
// the rock placement, so the three can never disagree about which edges are rock.

import { hexNoise } from '../elevation.js';
import { LEVEL_STEP, terrainLevelsActive } from '../terrainLevels.js';

export type CoastKind = 'beach' | 'cliff';

/** Biomes whose sea edge is rock, whatever the height (legacy, unlevelled boards). */
const ROCKY: ReadonlySet<string> = new Set(['mountain', 'hills', 'tundra']);
/** A land tile whose own elevation (above flat ground, world units) reaches this ends in a cliff. */
export const CLIFF_MIN_RISE = 0.1;
/** On a levelled board the cliff starts at a drop of this many terrain levels above the shore. */
export const CLIFF_MIN_LEVELS = 2;

/**
 * Beach or cliff for a land tile's sea edges. `rise` is the tile's elevation above flat ground (tileSurfaceY
 * minus LAND_TOP_LIFT). Legacy boards: rocky biomes or `rise >= CLIFF_MIN_RISE` end in a cliff, a quarter of
 * the forest coasts are rocky. Levelled boards (`terrain.levels`): the sim's level drop decides, two levels
 * or more above the shore is a cliff, so the same coast reads the same as the level legend.
 */
export function coastKindFor(
  biome: string,
  rise: number,
  q: number,
  r: number,
  levelled: boolean = terrainLevelsActive(),
): CoastKind {
  if (levelled) return rise >= CLIFF_MIN_LEVELS * LEVEL_STEP - 1e-6 ? 'cliff' : 'beach';
  if (ROCKY.has(biome) || rise >= CLIFF_MIN_RISE) return 'cliff';
  if (biome === 'forest' && hexNoise(q * 1.7 + 3, r * 2.3 - 1) < 0.25) return 'cliff';
  return 'beach';
}
